module.exports = __webpack_public_path__ + "media/images/carpenters-img-1-249a69855d50259530cc5b17cb3e01ae.jpg";